import {
  TYPE_DIMENSIONS,
  isStrictDimention
} from '../../core/type-dimensions';

require('./filter-value-input.component.scss');

export class FilterValueInputController {
  constructor(
    $scope,
    $element,
    $http, rx,
    observeOnScope,
    CurrentModelService,
    ErrorHandlerService
  ) {
    this.$scope = $scope;
    this.$element = $element;
    this.$http = $http;
    this.rx = rx;
    this.errorMessage = ErrorHandlerService.filterErrorMessage;
    this.CurrentModelService = CurrentModelService;
    this.filteredSuggestions = [];
    this.suggestions = [];
    this.isStrictDimention = isStrictDimention;
    this.needShowValue = false;
    this.current = {
      label: this.label,
      value: this.value
    };
    this.subscriptions = [
      rx.Observable.merge(
        rx.Observable.merge(
          observeOnScope($scope, '$ctrl.dimension'),
          observeOnScope($scope, '$ctrl.hierarchy'),
        ).do(() => {
          this.current = {
            label: this.label,
            oldLabel: this.label,
            value: this.value,
          };
        }),
        observeOnScope($scope, '$ctrl.current.label'),
        observeOnScope($scope, '$ctrl.focused'),
        observeOnScope($scope, '$ctrl.condition'),
      )
      .debounce(200)
      .do(() => {
        this.needShowValue = this.getNeedShowValue();
        if (this.boolean) {
          const key = `${this.dimension}.${this.hierarchy}`;
          this.suggestions = [{
              [key]: gettext('Да'),
              value: 'true'
            },
            {
              [key]: gettext('Нет'),
              value: 'false',
            },
          ];
          $scope.$digest();
        }
        if (this.isDictCondition && typeof this.value !== 'number') {
          this.value = '';
          this.current.value = '';
        }
        if (!this.isDictCondition && (typeof this.value === 'number' ||
            typeof this.current.value === 'number')) {
          this.current.value = '';
          this.current.label = '';
          this.value = '';
          this.label = '';
          this.errorMessage.text = '';
          this.errorMessage.error = false;
          if (!this.$scope.$root.$$phase) this.$scope.$apply();
        }
      })
      .filter(value => {
        return !this.boolean && this.focused;
      })
      .do(() => {
        this.loading = true;
        this.suggestions = [];
      })
      .switchMap(() => this.getSuggestions(this.current.label))
      .do(() => {
        this.loading = false;
      })
      .subscribe(
        suggestions => {
          this.suggestions = suggestions;
          $scope.$digest();
        },
        (error) => {
          console.error(error);
          this.loading = false;
          $scope.$digest();
        },
      ),
    ];
    this.error = false;
  }

  $onInit() {}

  $onDestroy() {
    this.subscriptions.forEach((s) => s.dispose());
  }

  setValue(suggestion) {
    if (this.boolean) {
      this.current = {
        label: suggestion.dropdownLabel,
        value: suggestion.value,
      };
    } else {
      this.value = suggestion.value;
      this.label = suggestion.label;
      this.current = {
        label: this.label,
        value: this.value,
      };
    }
    this.selected = true;
  }

  getSuggestions(lookup) {
    let url;
    if (this.isDictCondition) {
      let url = '/analytics/get_dictionary/';
      if (lookup) url = `${url}?lookup=${lookup}`;
      return this.rx.Observable.fromPromise(
          this.$http.get(url))
        .map(({
          data
        }) => data.map(d => ({
          label: d.name,
          value: d.id,
        })));
    } else {
      let url = `/analytics/values/${this.CurrentModelService.cube.name}/?drill=${this.fullDimension}&limit=100`;
      if (lookup) url = `${url}&lookup=${lookup}`;
      return this.rx.Observable.fromPromise(
          this.$http.get(url))
        .map(({
          data
        }) => data.cells.map(suggestion =>
          this.CurrentModelService.model.getCellFilter(
            this.fullDimension,
            suggestion,
          )
        ));
    }
  }

  onFocus() {
    this.focused = true;
    this.isOpen = true;
  }

  onChange() {
    this.selected = false;
  }

  getNeedShowValue() {
    const allow = {
      agent_eventtype: {
        default: true,
      },
      agent_time: {
        hour: true,
        time_zone: true,
        y: true,
      }
    };

    return !(allow[this.dimension] && allow[this.dimension][this.hierarchy]) &&
      this.isStrictDimention(this.dimension, this.hierarchy);
  }

  findAndSetValue() {
    if (this.suggestions.length) {
      let res = this.suggestions.find(s => s.label === this.current.label);
      if (res) return this.setValue(res);
      res = this.suggestions.find(s => s.label.indexOf(this.current.label) > -1);
      if (res) return this.setValue(res);
      res = this.suggestions.find(s => s.label.toUpperCase().indexOf(this.current.label.toUpperCase()) > -1);
      if (res) return this.setValue(res);
    }
    this.label = '';
    this.value = '';
    this.current.label = '';
    this.current.value = '';
  }

  get isDictCondition() {
    return this.condition == 'D' || this.condition == '!D';
  }

  onBlur() {
    this.focused = false;
    this.isOpen = false;
    if (this.isDictCondition || this.isStrictDimention(this.dimension, this.hierarchy)) {
      if (!this.selected)
        return this.findAndSetValue();
      if (this.current.value === this.current.label) {
        this.current.label = this.label;
        return null;
      }

    } else {
      if (!this.selected && (this.current.label || this.current.label === '')) {
        this.label = this.current.label;
        this.current.value = this.current.label;
        this.value = this.current.label;
      }
    }
  }

  get fullDimension() {
    try {
      const hierarchy = this.CurrentModelService.model.getHierarchy(
        `${this.dimension}@${this.hierarchy}`).toString();
      this.prevDimension = this.dimension;
      this.prevHierarchy = this.hierarchy;
      return hierarchy;
    } catch (err) {

      this.errorMessage.text = gettext('Неправильные параметры') + ` "dimension" : "${this.dimension}" ` +
        gettext('или') + ` "hierarchy" : "${this.hierarchy}"`;
      this.errorMessage.source = 'query-dimention';

      console.error(this.errorMessage.text);
      return 'agent_eventtype@default:agent_eventtype';
    }
  }

  getDropdownLabel(suggestion) {
    return this.needShowValue ? `${suggestion.value} (${suggestion.label})` : suggestion.label;
  }
}

export const FilterValueInputComponent = {
  bindings: {
    value: '=',
    label: '=',
    dimension: '<',
    condition: '<',
    multiple: '<',
    hierarchy: '<',
    boolean: '<',
    sting: '<',
  },
  template: require('./filter-value-input.component.html'),
  controller: FilterValueInputController,
};



// WEBPACK FOOTER //
// ./src/filter/query-builder/filter-value-input.component.js